/* eslint-disable @typescript-eslint/no-explicit-any */
import styled from 'styled-components';
import { darken, transparentize } from 'polished';

export const ContainerPage = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
`;

export const PageContent = styled.div`
  flex: 1;
  padding: 1rem;
  border-radius: 0.6rem;
  background-color: ${({ theme }) => theme.COLORS.WHITE};
  display: flex;
  flex-direction: column;
  overflow-y: auto;
`;

export const DeschargeContent = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  input {
    width: 220px;
    height: 48px;
    outline: none;
    padding: 0 0.8rem;
    border-radius: 0.4rem;
    background-color: #e9ecef;
    border: 1px solid ${({ theme }) => transparentize(0.8, theme.COLORS.GREY)};
    color: ${({ theme }) => theme.COLORS.GREY};
    margin-top: 0.3rem;
  }

  .row-input {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 30px;
  }

  .column-input {
    display: flex;
    flex-direction: column;
    margin-right: 1.5rem;
    margin-bottom: 0.8rem;
  }

  .dataMouths {
    display: flex;
    flex-direction: column;
  }

  .row-buttons {
    display: flex;
    flex-direction: row;
    margin-top: 1rem;
  }

  label {
    font-size: 0.9rem;
    color: ${({ theme }) => darken(0.2, theme.COLORS.GREY)};
  }

  h2 {
    font-size: 1.2rem;
    margin-bottom: 1rem;
    margin-top: 0.5rem;
    color: ${({ theme }) => theme.COLORS.GREEN_100};
    border-left: 4px solid ${({ theme }) => theme.COLORS.GREEN_100};
    padding-left: 0.5rem;
  }

  .line {
    width: 100%;
    height: 1px;
    margin: 1.5rem 0;
    background-color: ${({ theme }) => transparentize(0.9, theme.COLORS.GREY)};
  }

  .ContainerSilo {
    display: flex;
    gap: 2rem;
    flex-wrap: wrap;
    align-items: flex-start;
  }

  .totalVolumeBox {
    display: flex;
    align-items: baseline;
    gap: 20px;
    padding: 10px 16px;
    background-color: #e9ecef;
    border-radius: 8px;
    border: 1px solid #ced4da;
    margin-top: 1rem;

    h4 {
      margin: 0;
    }

    span {
      font-weight: bold;
      font-size: 1.2rem;
    }
  }
`;
